import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Driver } from "../models/driver.model";
import { Response } from '../models';
import { environment } from "../../../environments/environment";
import { firstValueFrom, Subject, takeUntil } from "rxjs";
import { Asset } from "../models/asset.model";


@Injectable({ providedIn: 'root' })
export class DriverService {

  private drivers: Array<Driver>;

  constructor(private http: HttpClient) { }

  getUserDrivers(accountIds: number[], cancellation: Subject<void>): Promise<Response<Array<Driver>>> {
    return firstValueFrom(this.http.post<Response<Array<Driver>>>(`${environment.apiEndpoint}/accounts/user-accounts-drivers`, { accountIds }).pipe(takeUntil(cancellation)));
  }

  setDrivers(drivers: Array<Driver>) {
    this.drivers = drivers;
  }

  getDrivers(): Array<Driver> {
    return this.drivers;
  }
}